module.exports = "https://www.gc-pro.gnp.com.mx/de8e9871dce7dab6c699593cbda56e36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/page_1_copy.svg
// module id = 1854
// module chunks = 0